import FormStyleKeys from 'forms-utils-lib/constants/formStyle/FormStyleKeys';
import TransitionTypes from 'forms-utils-lib/constants/formStyle/TransitionTypes';
import ProgressIndicatorThemes from 'forms-utils-lib/constants/formStyle/ProgressIndicatorThemes';
const DefaultFormStyle = {
  [FormStyleKeys.FONT_FAMILY]: 'arial, helvetica, sans-serif',
  [FormStyleKeys.BACKGROUND_WIDTH]: '100%',
  [FormStyleKeys.BACKGROUND_COLOR]: 'transparent',
  [FormStyleKeys.BORDER_RADIUS]: '0px',
  [FormStyleKeys.PADDING]: '0px',
  [FormStyleKeys.LABEL_TEXT_COLOR]: '#33475b',
  [FormStyleKeys.LINK_COLOR]: '#0000EE',
  [FormStyleKeys.CLICKED_LINK_COLOR]: '#551A8B',
  [FormStyleKeys.LABEL_TEXT_SIZE]: '14px',
  [FormStyleKeys.HELP_TEXT_COLOR]: '#537393',
  [FormStyleKeys.HELP_TEXT_SIZE]: '11px',
  [FormStyleKeys.LEGAL_CONSENT_TEXT_COLOR]: '#33475b',
  [FormStyleKeys.LEGAL_CONSENT_TEXT_SIZE]: '14px',
  [FormStyleKeys.THANK_YOU_TEXT_COLOR]: '#33475b',
  [FormStyleKeys.THANK_YOU_TEXT_SIZE]: '16px',
  [FormStyleKeys.SUBMIT_COLOR]: '#ff7a59',
  [FormStyleKeys.SUBMIT_ALIGNMENT]: 'left',
  [FormStyleKeys.SUBMIT_FONT_COLOR]: '#ffffff',
  [FormStyleKeys.SUBMIT_SIZE]: '12px',
  [FormStyleKeys.PAGINATION_PROGRESS_COLOR]: '#598aff',
  [FormStyleKeys.PAGINATION_PROGRESS_TEXT_COLOR]: '#33475b',
  [FormStyleKeys.PAGINATION_PROGRESS_SHOW]: true,
  [FormStyleKeys.PAGINATION_PROGRESS_TRANSITION]: TransitionTypes.FADE,
  [FormStyleKeys.PAGINATION_PROGRESS_THEME]: ProgressIndicatorThemes.DEFAULT,
  [FormStyleKeys.PAGINATION_CONTENT_USE_SCROLL]: false,
  [FormStyleKeys.PAGINATION_CONTENT_SCROLL_HEIGHT]: '100%'
};
export default DefaultFormStyle;